import { render, staticRenderFns } from "./checkRisk.vue?vue&type=template&id=01d93730&scoped=true&"
import script from "./checkRisk.vue?vue&type=script&lang=js&"
export * from "./checkRisk.vue?vue&type=script&lang=js&"
import style0 from "./checkRisk.vue?vue&type=style&index=0&id=01d93730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d93730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d93730')) {
      api.createRecord('01d93730', component.options)
    } else {
      api.reload('01d93730', component.options)
    }
    module.hot.accept("./checkRisk.vue?vue&type=template&id=01d93730&scoped=true&", function () {
      api.rerender('01d93730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/checkRisk.vue"
export default component.exports